import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';

export default {
  namespaced: true,
  state: {
    currentBrandOrAlias: '',
    autocompleteText: null,
    finded: {
      'aliases': '',
      'brand': null,
      'deleted': [],
    },
    isLoading: false,
    entries: [],
    count: 0 ,
    newBrandOrAlias:{
      type: '',
      brand: '',
      alias: ''
    },
  },

  getters:{
    getField, //vuex-map-fields

  },
  mutations: {
    updateField, //vuex-map-fields

  },
  actions: {
    //search(state, payload){
    autocomplete: function ({commit, state, dispatch}) {
      state.isLoading = true;
      return axios.post(this._vm.$apiURL + '/am/aliases/searchbystartslice', {
        'brand': state.autocompleteText
      })
        .then((response) => {
          state.count = response.data.data.length;
          state.entries = response.data.data;
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(() => (state.isLoading = false))
    },
    getData: function ({commit, state, dispatch}) {
      return axios.post(this._vm.$apiURL + '/am/aliases/search', {
        'brand':state.currentBrandOrAlias
      })
        .then((response) => {
          if (response.data.aliases) {
            state.finded = response.data;
          } else{
            state.finded = {
              'aliases': '',
              'brand': null,
              'deleted': []
            }
          }
        })
        .catch((error) => {
          state.finded = {
            'alias':'',
            'brand':'',
            'deleted':[]
          };
            dispatch('common/showError', {'error': error}, {root:true});
        });
    },
    delete: async function({commit, state, dispatch}, payload){
      return await axios.post(this._vm.$apiURL + '/am/aliases/delete', {
        'type': payload.type,
        'title': payload.title,
      })
        .then((response) => {
          if (response.data.status ==='success') {
            return response.data.status;
          }
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        });
    },
    restore: async function({commit, state, dispatch}, payload){
      return await axios.post(this._vm.$apiURL + '/am/aliases/restore', {
        'title':payload.title,
        'type':payload.type,
      })
        .then((response) => {
          if (response.data.status ==='success') {
            return response.data.status;
          }
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        });
    },
    addNew: async function({commit, state, dispatch}){
      let data = {
        'type':state.newBrandOrAlias.type,
        'title':(state.newBrandOrAlias.type==='alias')?state.newBrandOrAlias.alias:state.newBrandOrAlias.brand,
      };
      if(state.newBrandOrAlias.type==='alias' && state.finded.brand!==null) data['brand'] = state.finded.brand;
      return await axios.post(this._vm.$apiURL + '/am/aliases/add', data)
        .then((response) => {
          if (response.data.status ==='success') {
            state.currentBrandOrAlias = (state.newBrandOrAlias.type==='alias') ? state.newBrandOrAlias.alias : state.newBrandOrAlias.brand;
            state.newBrandOrAlias = {
              type: 'brand',
              brand: '',
              alias: ''
            }
            return response.data.status;
          }
        })
        .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
        });
    },
    restoreSettings: async function({commit, state, dispatch}) {
      return await this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('viewAMAliases.delete_all_settings'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( async y =>{
        return await axios.post(this._vm.$apiURL+'/am/aliases/clear')
          .then(async response => {
            if(response.data.status==='success'){
              state.finded = {
                aliases: '',
                brand: null,
                deleted: [],
              };
              state.newBrandOrAlias ={
                type: '',
                brand: '',
                alias: ''
              }
              return response.data.status;
            }
          })
          .catch(error => {
              dispatch('common/showError', {'error': error}, {root:true});
          });
      })
    }
  }
}
